import React from 'react';
import { useSelector } from 'react-redux';

import * as TRANSCRIPTION from '../../../../../../shared/constants/videoTranscript';
import EmptyTranscript from '../emptyTranscript';
import TranscriptList from '../transcript-list';
import {
  selectTranscriptionStatus,
  selectTranscriptPhrases,
} from 'selectors/transcripts';

const TranscriptWrapper = ({ showFullHeader, setShowFullHeader }) => {
  const transcriptStatus = useSelector(selectTranscriptionStatus);
  const transcript = useSelector(selectTranscriptPhrases);

  return transcript ? (
    <TranscriptList
      transcript={transcript}
      showFullHeader={showFullHeader}
      setShowFullHeader={setShowFullHeader}
    />
  ) : (
    <EmptyTranscript
      failed={
        transcriptStatus === TRANSCRIPTION.FAILED ||
        transcriptStatus === TRANSCRIPTION.SHORT_DURATION ||
        !TRANSCRIPTION.TRANSCRIPTION_STATUSES.includes(transcriptStatus)
      }
      empty={transcriptStatus === TRANSCRIPTION.NO_AUDIO}
    />
  );
};

export default TranscriptWrapper;
